import React, {useState} from 'react';
import {t} from "i18next";
import {Modal} from "@/components/Modal";
import {ChevronDownIcon} from "@radix-ui/react-icons";
import {Transition} from "@headlessui/react";
import {addProfession} from "@/service/accountApi";

export const AddProfessionForm = (props) => {
	const {showAddProfessionForm, setShowAddProfessionForm, accountDetails, setAccountDetails} = props;

	const [error, setError] = useState({});

	const [isEmploymentTypeDropdownOpen, setIsEmploymentTypeDropdownOpen] = useState(false);
	const [isSelectingEmploymentType, setIsSelectingEmploymentType] = useState(false);

	const [isAddProfessionButtonDisabled, setIsAddProfessionButtonDisabled] = useState(false);

	const [professionDetails, setProfessionDetails] = useState({
		employmentTitle: '',
		businessOrCompanyName: '',

		employmentType: '',
		startDate: '',
		endDate: '',

		isCurrentProfession: false,

		city: '',
		state: '',
		country: '',
	});

	const [needAssistance, setNeedAssistance] = useState(false);
	const [needAssistanceDescription, setNeedAssistanceDescription] = useState('');

	const employmentTypeLabel = (employmentType) => {
		switch (employmentType) {
			case 'Service':
				return t("PROFESSION_FORM.EMPLOYMENT_TYPE.SERVICE");
			case 'Business':
				return t("PROFESSION_FORM.EMPLOYMENT_TYPE.BUSINESS");
			case 'Retired':
				return t("PROFESSION_FORM.EMPLOYMENT_TYPE.RETIRED");
			default:
				return "";
		}
	}

	const handleEmploymentTypeSelect = (employmentType) => {
		setIsSelectingEmploymentType(false);
		setIsEmploymentTypeDropdownOpen(false);
		setProfessionDetails({
			...professionDetails,
			employmentType: employmentType
		});

		setError({
			...error,
			employmentType: ""
		})
	}

	const handleFormData = (e) => {
		console.log(e.target.name + ': ' + e.target.value);

		setProfessionDetails({
			...professionDetails,
			[e.target.name]: e.target.value
		});

		setError({
			...error,
			[e.target.name]: ""
		});
	}

	const validate = () => {
		let err = {};

		if (professionDetails.employmentTitle === '') {
			err['employmentTitle'] = t("PROFESSION_FORM.EMPLOYMENT_TITLE.REQUIRED_ERROR");
		}

		if (professionDetails.businessOrCompanyName === '') {
			err['businessOrCompanyName'] = t("PROFESSION_FORM.BUSINESS_OR_COMPANY_NAME.REQUIRED_ERROR");
		}

		if (professionDetails.employmentType === '') {
			err['employmentType'] = t("PROFESSION_FORM.EMPLOYMENT_TYPE.REQUIRED_ERROR");
		}

		if (professionDetails.startDate === '') {
			err['startDate'] = t("PROFESSION_FORM.START_DATE.REQUIRED_ERROR");
		}

		if (!professionDetails.isCurrentProfession) {
			if (professionDetails.endDate === '') {
				err['endDate'] = t("PROFESSION_FORM.END_DATE.REQUIRED_ERROR");
			}
		}

		if (professionDetails.city === '') {
			err['city'] = t("PROFESSION_FORM.CITY.REQUIRED_ERROR");
		}

		if (professionDetails.state === '') {
			err['state'] = t("PROFESSION_FORM.STATE.REQUIRED_ERROR");
		}

		if (professionDetails.country === '') {
			err['country'] = t("PROFESSION_FORM.COUNTRY.REQUIRED_ERROR");
		}

		return err;
	}

	const handleSubmit = async () => {
		console.log("Inside Handle Submit!");
		setIsAddProfessionButtonDisabled(true);
		const err = validate();

		if (Object.keys(err).length > 0) {
			setError(err);
			setIsAddProfessionButtonDisabled(false);
			return;
		}

		console.log("Profession Details: ", professionDetails);
		const professionData = {
			userAccountId: accountDetails._id,
			professionDetails: professionDetails,
		};
		const addProfessionDataResponse = await addProfession(professionData);

		console.log('(AddProfessionForm) Add Profession Data Response: ', addProfessionDataResponse);

		if (addProfessionDataResponse.success) {
			setAccountDetails(addProfessionDataResponse.data);
			setShowAddProfessionForm(false);
			setIsAddProfessionButtonDisabled(false);
			setTimeout(() => {
				setProfessionDetails({
					schoolOrCollegeName: '',
					businessOrCompanyName: '',

					employmentType: '',
					startDate: '',
					endDate: '',

					isCurrentProfession: false,

					city: '',
					state: '',
					country: '',
				});
			}, 200);
		}
	}

	return (
		<Modal isOpen={showAddProfessionForm}>
			<div className="form-modal-container">
				{/* Header */}
				<div className={"form-modal-header-container"}>
					{/* Header Title | Close Button */}
					<div className={"flex flex-row items-center justify-between"}>
						{/* Form Title */}
						<h2>
							{t("PROFESSION_FORM.ADD_TITLE")}
						</h2>

						{/* Close Button */}
						<button
							onClick={() => {
								setTimeout(() => {
									setProfessionDetails({
										schoolOrCollegeName: '',
										businessOrCompanyName: '',

										employmentType: '',
										startDate: '',
										endDate: '',

										isCurrentProfession: false,

										city: '',
										state: '',
										country: '',
									});
								}, 200);
								setShowAddProfessionForm(false);
							}}
						>
							<img
								className={"w-[75%] h-[75%]"}
								src={"/assets/close-icon.png"}
								alt={"Close"}
								title={"Close"}
							/>
						</button>
					</div>

					{/* Divider */}
					<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
				</div>

				{/* Form Fields */}
				<div className={"form-modal-body-container"}>
					{/* Employment Title */}
					<fieldset>
						<div className="custom-input-container">
							<label htmlFor="employmentTitle">
								{t("PROFESSION_FORM.EMPLOYMENT_TITLE.LABEL")}
							</label>

							<div className="flex-1 flex flex-col">
								<input
									id="employmentTitle"
									className="custom-input"
									name='employmentTitle'
									value={professionDetails.employmentTitle}
									onChange={handleFormData}
								/>
								{
									error['employmentTitle'] &&
									<p className="custom-input-error-message" id="error">
										{error['employmentTitle']}
									</p>
								}
							</div>
						</div>
					</fieldset>

					{/* Business or Company Name */}
					<fieldset>
						<div className="custom-input-container">
							<label htmlFor="businessOrCompanyName">
								{t("PROFESSION_FORM.BUSINESS_OR_COMPANY_NAME.LABEL")}
							</label>

							<div className="flex-1 flex flex-col">
								<input
									id="businessOrCompanyName"
									className="custom-input"
									name='businessOrCompanyName'
									value={professionDetails.businessOrCompanyName}
									onChange={handleFormData}
								/>
								{
									error['businessOrCompanyName'] &&
									<p className="custom-input-error-message" id="error">
										{error['businessOrCompanyName']}
									</p>
								}
							</div>
						</div>
					</fieldset>

					{/* Employment Type | Start Date | End Date */}
					<fieldset>
						<div className="custom-input-multiple-fields-container">
							{/* Employment Type */}
							<div className="custom-input-container">
								<label htmlFor="employmentType">
									{t("PROFESSION_FORM.EMPLOYMENT_TYPE.LABEL")}
								</label>

								<div className="w-full h-full flex flex-col">
									<button
										onBlur={() => {
											if (!isSelectingEmploymentType) {
												setIsEmploymentTypeDropdownOpen(false);
											}
										}}
										className="custom-input-dropdown-button"
										onClick={() => setIsEmploymentTypeDropdownOpen(!isEmploymentTypeDropdownOpen)}
									>
										<p className={""}>
											{employmentTypeLabel(professionDetails.employmentType)}
										</p>

										<ChevronDownIcon
											className={`${isEmploymentTypeDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
											aria-hidden="true"
											stroke="#292D32"
											strokeWidth={"0.1vh"}
										/>
									</button>

									{/* Employment Type Dropdown */}
									<div className={"relative"}>
										<Transition show={isEmploymentTypeDropdownOpen}>
											<div
												className={`bg-white absolute left-0 right-0 z-[100] max-h-[15vh]
                                                    origin-top-right rounded-md shadow-2xl 
                                                    border border-gray-700 overflow-y-scroll
                                                    data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                    data-[enter]:duration-100 data-[enter]:ease-out 
                                                    data-[leave]:duration-75 data-[leave]:ease-in`}
											>
												<button
													className="custom-input-dropdown-list-button"
													onMouseDown={() => setIsSelectingEmploymentType(true)}
													onClick={() => handleEmploymentTypeSelect("Service")}
												>
													<p className={""}>
														{t("PROFESSION_FORM.EMPLOYMENT_TYPE.SERVICE")}
													</p>
												</button>
												<button
													className="custom-input-dropdown-list-button"
													onMouseDown={() => setIsSelectingEmploymentType(true)}
													onClick={() => handleEmploymentTypeSelect("Business")}
												>
													<p className={""}>
														{t("PROFESSION_FORM.EMPLOYMENT_TYPE.BUSINESS")}
													</p>
												</button>
												<button
													className="custom-input-dropdown-list-button"
													onMouseDown={() => setIsSelectingEmploymentType(true)}
													onClick={() => handleEmploymentTypeSelect("Retired")}
												>
													<p className={""}>
														{t("PROFESSION_FORM.EMPLOYMENT_TYPE.RETIRED")}
													</p>
												</button>
											</div>
										</Transition>
									</div>

									{
										error['employmentType'] &&
										<p className="custom-input-error-message" id="error">
											{error['employmentType']}
										</p>
									}
								</div>
							</div>

							{/* Start Date */}
							<div className="custom-input-container">
								<label htmlFor='startDate'>
									{t("PROFESSION_FORM.START_DATE.LABEL")}
								</label>
								<div className="relative w-full">
									<input
										type={"month"}
										name='startDate'
										required
										value={professionDetails.startDate}
										onChange={handleFormData}
										className={`custom-input`}
									/>
									{
										error['startDate'] &&
										<p className="custom-input-error-message" id="error">
											{error['startDate']}
										</p>
									}
								</div>
							</div>

							{/* End Date */}
							<div className="custom-input-container">
								<label
									className=''
									htmlFor='endDate'
								>
									{t("PROFESSION_FORM.END_DATE.LABEL")}
								</label>
								<div className="relative w-full">
									<input
										disabled={professionDetails.isCurrentProfession}
										type={"month"}
										name='endDate'
										value={professionDetails.endDate}
										onChange={handleFormData}
										className="custom-input"
									/>
									{
										error['endDate'] &&
										<p className="custom-input-error-message" id="error">
											{error['endDate']}
										</p>
									}
								</div>
							</div>
						</div>
					</fieldset>

					{/* Current Profession CheckBox */}
					<fieldset>
						<label className="custom-input-label-checkbox">
							<input
								type="checkbox"
								name='isCurrentProfession'
								checked={professionDetails.isCurrentProfession}
								onChange={(e) => {
									console.log("Is Current Profession: ", e.target.checked);
									setProfessionDetails({
										...professionDetails,
										isCurrentProfession: e.target.checked
									});
								}}
							/>
							<p>
								{t("PROFESSION_FORM.PRESENT")}
							</p>
						</label>
					</fieldset>

					{/* City | State | Country */}
					<fieldset>
						<div className="custom-input-multiple-fields-container flex-wrap">
							{/* City */}
							<div className="custom-input-container">
								<label htmlFor="city">
									{t("PROFESSION_FORM.CITY.LABEL")}
								</label>

								<div className="flex-1 flex flex-col">
									<input
										id="city"
										className="custom-input"
										name='city'
										value={professionDetails.city}
										onChange={handleFormData}
									/>
									{
										error['city'] &&
										<p className="custom-input-error-message" id="error">
											{error['city']}
										</p>
									}
								</div>
							</div>

							{/* State */}
							<div className="custom-input-container">
								<label
									className=""
									htmlFor="state"
								>
									{t("PROFESSION_FORM.STATE.LABEL")}
								</label>

								<div className="flex-1 flex flex-col">
									<input
										id="state"
										className="custom-input"
										name='state'
										value={professionDetails.state}
										onChange={handleFormData}
									/>
									{
										error['state'] &&
										<p className="custom-input-error-message" id="error">
											{error['state']}
										</p>
									}
								</div>
							</div>

							{/* Country */}
							<div className="custom-input-container">
								<label
									className=""
									htmlFor="country"
								>
									{t("PROFESSION_FORM.COUNTRY.LABEL")}
								</label>

								<div className="flex-1 flex flex-col">
									<input
										id="country"
										className="custom-input"
										name='country'
										value={professionDetails.country}
										onChange={handleFormData}
									/>
									{
										error['country'] &&
										<p className="custom-input-error-message" id="error">
											{error['country']}
										</p>
									}
								</div>
							</div>
						</div>
					</fieldset>
				</div>

				{/* Footer */}
				<div className={"form-modal-footer-container"}>
					{/* Divider */}
					<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

					{/* Submit Button Container */}
					<div className="flex items-center justify-end">
						{/* Submit Button */}
						<button
							disabled={isAddProfessionButtonDisabled}
							onClick={handleSubmit}
							className="form-modal-footer-container-submit-button"
						>
							<p>
								{t("PROFESSION_FORM.ADD_SUBMIT")}
							</p>
							<svg
								viewBox="0 0 6 6"
								fill="none"
								id={"arrow-icon"}
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M3 1L5 3L3 5"
									id={"arrow-icon-tip"}
									stroke="black"
									strokeLinecap="square"
								/>
								<path
									d="M1 3L4 3"
									id={"arrow-icon-line"}
									stroke="black"
									strokeLinecap="square"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
}
